/** Stored BusinessLevel values → UI display labels (label-map only). */
export const BUSINESS_LEVEL_VALUES = ['MasterAdmin', 'Division', 'Subdivision', 'Business'] as const

export type BusinessLevelValue = (typeof BUSINESS_LEVEL_VALUES)[number]

export const BUSINESS_LEVEL_LABELS: Record<string, string> = {
  MasterAdmin: 'Group',
  Division: 'Divisional',
  Subdivision: 'Regional',
  Business: 'Business Entity',
}

export function formatBusinessLevel(level?: string | null): string {
  if (!level) return 'Business Entity'
  return BUSINESS_LEVEL_LABELS[level] ?? level
}

/** Profile is complete when scope matches level rules (and not auto-provisioned pending). */
export function isProfileComplete(user: {
  businessLevel?: string | null
  divisionId?: string | null
  subdivisionId?: string | null
  businessEntityIds?: string[] | null
  isAutoProvisioned?: boolean
  isProfileComplete?: boolean
}): boolean {
  if (typeof user.isProfileComplete === 'boolean') return user.isProfileComplete
  if (user.isAutoProvisioned) return false
  const level = user.businessLevel || 'Business'
  if (level === 'MasterAdmin') return true
  if (level === 'Division') return !!user.divisionId
  if (level === 'Subdivision') return !!user.subdivisionId
  if (level === 'Business') return (user.businessEntityIds?.length ?? 0) > 0
  return false
}

/** Matches API UserHasPublisherRole: Publisher claim or MasterAdmin. */
export function canApproveProducts(user?: {
  functionalRoles?: string[] | null
  businessLevel?: string | null
  role?: string | null
} | null): boolean {
  if (!user) return false
  const roles = (user.functionalRoles ?? []).map((role) => role.toLowerCase())
  if (roles.includes('publisher') || roles.includes('masteradmin')) return true
  const level = (user.businessLevel ?? user.role ?? '').toLowerCase()
  return level === 'masteradmin'
}
